import HTTP from '@/utils/http'
import notification from '@/utils/notification'
import { markTenantProjectsDashboardListStale } from '@/store/dashboardListStale'
const PREFIX_PATH = '/insurances'

export async function create (data) {
  try {
    const response = await HTTP.post(`${PREFIX_PATH}`, data)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return null
  }
}

export async function get (params, isSilentGet) {
  try {
    const get = isSilentGet ? HTTP.silentGet : HTTP.get
    const response = await get(`${PREFIX_PATH}`, { params })
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return []
  }
}

export async function update (id, data) {
  try {
    const response = await HTTP.put(`${PREFIX_PATH}/${id}`, data)
    markTenantProjectsDashboardListStale()
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return {}
  }
}

export async function getById (id) {
  try {
    const response = await HTTP.get(`${PREFIX_PATH}/${id}`)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return {}
  }
}
